import { get } from 'lodash-es';
import store from 'redux/store';

export const themeProp = path => props => get(props.theme, path, '');

export const createPropGetter = (path, getter) => restOfPath => {
  if (typeof getter === 'function') {
    return getter(`${path}.${restOfPath}`);
  }

  return themeProp(`${path}.${restOfPath}`);
};

export const getThemeValueWithCondition = ({
  condition = false,
  passValue,
  defaultValue
}) => {
  if (condition) return passValue;

  return defaultValue;
};

export const getThemeFontSize = size => props =>
  themeProp(`global.fontSizes.${size}`)(props);

export const isMerchantPassedCustomValue = ({ propPath = '' }) => {
  if (!propPath) return false;

  const { global: { customStyles = {} } = {} } = store.getState();

  return !!get(customStyles, propPath, '');
};
